export default "__VITE_ASSET__CU2Af7vM__"